import { lazy } from "react";

const WelcomeOepPage = lazy(() => import("./pages/WelcomeOepPage"));

export const welcomeOepRoutes = [
  { path: "/welcome-oep", element: <WelcomeOepPage /> },
];
